export default {
  data() {
    return {
      backFill1: 'none',
      backFill2: 'none',
      backFill3: 'none',
      backFill4: 'none',
      backgroundColor5: 'transparent',
      backgroundColor6: 'transparent',
      backgroundColor7: 'transparent',
      backFill5: 'rectangle-7037',
      backFill6: 'rectangle-7039',
      backFill7: 'rectangle-7038',
      backFill8: 'none',
      backFill9: 'none',
      backFill10: 'none',
      backFill11: 'none',
      backFill12: 'none',
      backFill13: 'none',
      backFill14: 'none',
      backFill15: 'none',
      backFill16: 'none',
      backFill17: 'none',
      backFill18: 'none',
      backFill19: 'none',
      backFill20: 'none',
      backFill21: 'none',
      backFill22: 'none',
      backFill23: 'none',
      backgroundColor24: 'transparent',
      backFill24: 'rectangle-7040',
      backFill25: 'none',
      backFill26: 'none',
      backFill27: 'none',
      backFill28: 'none',
      backFill29: 'none',
      backFill30: 'none',
      backFill31: 'none',
      backFill32: 'none',
      backFill33: 'none',
      backFill34: 'none',
      backFill35: 'none',
      backFill36: 'none',
      backFill37: 'none',
      backFill38: 'none',
      //tooltip
      toolTip28: '',
    };
  },
  methods: {
    backPartClick: function (item) {
      if (this.hasBackClick) {
        if (item == 1) {
          this.backFill1 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 2) {
          this.backFill2 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 3) {
          this.backFill3 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 4) {
          this.backFill4 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 5) {
          this.backFill5 = 'rectangle-7037-fill';
          this.$emit('backPartClick', item);
        } else if (item == 6) {
          this.backFill6 = 'rectangle-7039-fill';
          this.$emit('backPartClick', item);
        } else if (item == 7) {
          this.backFill7 = 'rectangle-7038-fill';
          this.$emit('backPartClick', item);
        } else if (item == 8) {
          this.backFill8 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 9) {
          this.backFill9 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 10) {
          this.backFill10 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 11) {
          this.backFill11 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 12) {
          this.backFill12 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 13) {
          this.backFill13 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 14) {
          this.backFill14 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 15) {
          this.backFill15 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 16) {
          this.backFill16 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 17) {
          this.backFill17 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 18) {
          this.backFill18 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 19) {
          this.backFill19 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 20) {
          this.backFill20 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 21) {
          this.backFill21 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 22) {
          this.backFill22 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 23) {
          this.backFill23 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 24) {
          this.backFill24 = 'rectangle-7040-fill';
          this.$emit('backPartClick', item);
        } else if (item == 25) {
          this.backFill25 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 26) {
          this.backFill26 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 27) {
          this.backFill27 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 28) {
          this.backFill28 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 29) {
          this.backFill29 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 30) {
          this.backFill30 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 31) {
          this.backFill31 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 32) {
          this.backFill32 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 33) {
          this.backFill33 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 34) {
          this.backFill34 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 35) {
          this.backFill35 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 36) {
          this.backFill36 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 37) {
          this.backFill37 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 38) {
          this.backFill38 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 39) {
          this.backFill39 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 40) {
          this.backFill40 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 41) {
          this.backFill41 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 42) {
          this.backFill42 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 43) {
          this.backFill43 = '#0A6ADA';
          this.$emit('backPartClick', item);
        } else if (item == 44) {
          this.backFill44 = '#0A6ADA';
          this.$emit('backPartClick', item);
        }
      }
    },
    clearPart: function (item) {
      if (item == 1) {
        this.backFill1 = 'none';
      } else if (item == 2) {
        this.backFill2 = 'none';
      } else if (item == 3) {
        this.backFill3 = 'none';
      } else if (item == 4) {
        this.backFill4 = 'none';
      } else if (item == 5) {
        this.backFill5 = 'rectangle-7037';
      } else if (item == 6) {
        this.backFill6 = 'rectangle-7039';
      } else if (item == 7) {
        this.backFill7 = 'rectangle-7038';
      } else if (item == 8) {
        this.backFill8 = 'none';
      } else if (item == 9) {
        this.backFill9 = 'none';
      } else if (item == 10) {
        this.backFill10 = 'none';
      } else if (item == 11) {
        this.backFill11 = 'none';
      } else if (item == 12) {
        this.backFill12 = 'none';
      } else if (item == 13) {
        this.backFill13 = 'none';
      } else if (item == 14) {
        this.backFill14 = 'none';
      } else if (item == 15) {
        this.backFill15 = 'none';
      } else if (item == 16) {
        this.backFill16 = 'none';
      } else if (item == 17) {
        this.backFill17 = 'none';
      } else if (item == 18) {
        this.backFill18 = 'none';
      } else if (item == 19) {
        this.backFill19 = 'none';
      } else if (item == 20) {
        this.backFill20 = 'none';
      } else if (item == 21) {
        this.backFill21 = 'none';
      } else if (item == 22) {
        this.backFill22 = 'none';
      } else if (item == 23) {
        this.backFill23 = 'none';
      } else if (item == 24) {
        this.backFill24 = 'rectangle-7040';
      } else if (item == 25) {
        this.backFill25 = 'none';
      } else if (item == 26) {
        this.backFill26 = 'none';
      } else if (item == 27) {
        this.backFill27 = 'none';
      } else if (item == 28) {
        this.backFill28 = 'none';
      } else if (item == 29) {
        this.backFill29 = 'none';
      } else if (item == 30) {
        this.backFill30 = 'none';
      } else if (item == 31) {
        this.backFill31 = 'none';
      } else if (item == 32) {
        this.backFill32 = 'none';
      } else if (item == 33) {
        this.backFill33 = 'none';
      } else if (item == 34) {
        this.backFill34 = 'none';
      } else if (item == 35) {
        this.backFill35 = 'none';
      } else if (item == 36) {
        this.backFill36 = 'none';
      } else if (item == 37) {
        this.backFill37 = 'none';
      } else if (item == 38) {
        this.backFill38 = 'none';
      } else if (item == 39) {
        this.backFill39 = 'none';
      } else if (item == 40) {
        this.backFill40 = 'none';
      } else if (item == 41) {
        this.backFill41 = 'none';
      } else if (item == 42) {
        this.backFill42 = 'none';
      } else if (item == 43) {
        this.backFill43 = 'none';
      } else if (item == 44) {
        this.backFill44 = 'none';
      }
    },
    colorPart: function (item) {
      if (item == 1) {
        this.backFill1 = '#0A6ADA';
      } else if (item == 2) {
        this.backFill2 = '#0A6ADA';
      } else if (item == 3) {
        this.backFill3 = '#0A6ADA';
      } else if (item == 4) {
        this.backFill4 = '#0A6ADA';
      } else if (item == 5) {
        this.backFill5 = 'rectangle-7037-fill';
      } else if (item == 6) {
        this.backFill6 = 'rectangle-7039-fill';
      } else if (item == 7) {
        this.backFill7 = 'rectangle-7038-fill';
      } else if (item == 8) {
        this.backFill8 = '#0A6ADA';
      } else if (item == 9) {
        this.backFill9 = '#0A6ADA';
      } else if (item == 10) {
        this.backFill10 = '#0A6ADA';
      } else if (item == 11) {
        this.backFill11 = '#0A6ADA';
      } else if (item == 12) {
        this.backFill12 = '#0A6ADA';
      } else if (item == 13) {
        this.backFill13 = '#0A6ADA';
      } else if (item == 14) {
        this.backFill14 = '#0A6ADA';
      } else if (item == 15) {
        this.backFill15 = '#0A6ADA';
      } else if (item == 16) {
        this.backFill16 = '#0A6ADA';
      } else if (item == 17) {
        this.backFill17 = '#0A6ADA';
      } else if (item == 18) {
        this.backFill18 = '#0A6ADA';
      } else if (item == 19) {
        this.backFill19 = '#0A6ADA';
      } else if (item == 20) {
        this.backFill20 = '#0A6ADA';
      } else if (item == 21) {
        this.backFill21 = '#0A6ADA';
      } else if (item == 22) {
        this.backFill22 = '#0A6ADA';
      } else if (item == 23) {
        this.backFill23 = '#0A6ADA';
      } else if (item == 24) {
        this.backFill24 = 'rectangle-7040-fill';
      } else if (item == 25) {
        this.backFill25 = '#0A6ADA';
      } else if (item == 26) {
        this.backFill26 = '#0A6ADA';
      } else if (item == 27) {
        this.backFill27 = '#0A6ADA';
      } else if (item == 28) {
        this.backFill28 = '#0A6ADA';
      } else if (item == 29) {
        this.backFill29 = '#0A6ADA';
      } else if (item == 30) {
        this.backFill30 = '#0A6ADA';
      } else if (item == 31) {
        this.backFill31 = '#0A6ADA';
      } else if (item == 32) {
        this.backFill32 = '#0A6ADA';
      } else if (item == 33) {
        this.backFill33 = '#0A6ADA';
      } else if (item == 34) {
        this.backFill34 = '#0A6ADA';
      } else if (item == 35) {
        this.backFill35 = '#0A6ADA';
      } else if (item == 36) {
        this.backFill36 = '#0A6ADA';
      } else if (item == 37) {
        this.backFill37 = '#0A6ADA';
      } else if (item == 38) {
        this.backFill38 = '#0A6ADA';
      } else if (item == 39) {
        this.backFill39 = '#0A6ADA';
      } else if (item == 40) {
        this.backFill40 = '#0A6ADA';
      } else if (item == 41) {
        this.backFill41 = '#0A6ADA';
      } else if (item == 42) {
        this.backFill42 = '#0A6ADA';
      } else if (item == 43) {
        this.backFill43 = '#0A6ADA';
      } else if (item == 44) {
        this.backFill44 = '#0A6ADA';
      }
    },
    setColorToEachPart: function (bodyPartId, color) {
      if (bodyPartId == 1) {
        this.backFill1 = color;
      } else if (bodyPartId == 2) {
        this.backFill2 = color;
      } else if (bodyPartId == 3) {
        this.backFill3 = color;
      } else if (bodyPartId == 4) {
        this.backFill4 = color;
      } else if (bodyPartId == 5) {
        this.backFill5 = 'rectangle-7037-fill';
        this.backgroundColor5 = color;
      } else if (bodyPartId == 6) {
        this.backFill6 = 'rectangle-7039-fill';
        this.backgroundColor6 = color;
      } else if (bodyPartId == 7) {
        this.backFill7 = 'rectangle-7038-fill';
        this.backgroundColor7 = color;
      } else if (bodyPartId == 8) {
        this.backFill8 = color;
      } else if (bodyPartId == 9) {
        this.backFill9 = color;
      } else if (bodyPartId == 10) {
        this.backFill10 = color;
      } else if (bodyPartId == 11) {
        this.backFill11 = color;
      } else if (bodyPartId == 12) {
        this.backFill12 = color;
      } else if (bodyPartId == 13) {
        this.backFill13 = color;
      } else if (bodyPartId == 14) {
        this.backFill14 = color;
      } else if (bodyPartId == 15) {
        this.backFill15 = color;
      } else if (bodyPartId == 16) {
        this.backFill16 = color;
      } else if (bodyPartId == 17) {
        this.backFill17 = color;
      } else if (bodyPartId == 18) {
        this.backFill18 = color;
      } else if (bodyPartId == 19) {
        this.backFill19 = color;
      } else if (bodyPartId == 20) {
        this.backFill20 = color;
      } else if (bodyPartId == 21) {
        this.backFill21 = color;
      } else if (bodyPartId == 22) {
        this.backFill22 = color;
      } else if (bodyPartId == 23) {
        this.backFill23 = color;
      } else if (bodyPartId == 24) {
        this.backFill24 = 'rectangle-7040-fill';
        this.backgroundColor24 = color;
      } else if (bodyPartId == 25) {
        this.backFill25 = color;
      } else if (bodyPartId == 26) {
        this.backFill26 = color;
      } else if (bodyPartId == 27) {
        this.backFill27 = color;
      } else if (bodyPartId == 28) {
        this.backFill28 = color;
      } else if (bodyPartId == 29) {
        this.backFill29 = color;
      } else if (bodyPartId == 30) {
        this.backFill30 = color;
      } else if (bodyPartId == 31) {
        this.backFill31 = color;
      } else if (bodyPartId == 32) {
        this.backFill32 = color;
      } else if (bodyPartId == 33) {
        this.backFill33 = color;
      } else if (bodyPartId == 34) {
        this.backFill34 = color;
      } else if (bodyPartId == 35) {
        this.backFill35 = color;
      } else if (bodyPartId == 36) {
        this.backFill36 = color;
      } else if (bodyPartId == 37) {
        this.backFill37 = color;
      } else if (bodyPartId == 38) {
        this.backFill38 = color;
      } else if (bodyPartId == 39) {
        this.backFill39 = color;
      } else if (bodyPartId == 40) {
        this.backFill40 = color;
      } else if (bodyPartId == 41) {
        this.backFill41 = color;
      } else if (bodyPartId == 42) {
        this.backFill42 = color;
      } else if (bodyPartId == 43) {
        this.backFill43 = color;
      } else if (bodyPartId == 44) {
        this.backFill44 = color;
      }
    },
    clearAllParts: function () {
      (this.backFill1 = 'none'),
        (this.backFill2 = 'none'),
        (this.backFill3 = 'none'),
        (this.backFill4 = 'none'),
        (this.backgroundColor5 = 'transparent'),
        (this.backgroundColor6 = 'transparent'),
        (this.backgroundColor7 = 'transparent'),
        (this.backFill5 = 'rectangle-7037'),
        (this.backFill6 = 'rectangle-7039'),
        (this.backFill7 = 'rectangle-7038'),
        (this.backFill8 = 'none'),
        (this.backFill9 = 'none'),
        (this.backFill10 = 'none'),
        (this.backFill11 = 'none'),
        (this.backFill12 = 'none'),
        (this.backFill13 = 'none'),
        (this.backFill14 = 'none'),
        (this.backFill15 = 'none'),
        (this.backFill16 = 'none'),
        (this.backFill17 = 'none'),
        (this.backFill18 = 'none'),
        (this.backFill19 = 'none'),
        (this.backFill20 = 'none'),
        (this.backFill21 = 'none'),
        (this.backFill22 = 'none'),
        (this.backFill23 = 'none'),
        (this.backgroundColor24 = 'transparent'),
        (this.backFill24 = 'rectangle-7040'),
        (this.backFill25 = 'none'),
        (this.backFill26 = 'none'),
        (this.backFill27 = 'none'),
        (this.backFill28 = 'none'),
        (this.backFill29 = 'none'),
        (this.backFill30 = 'none'),
        (this.backFill31 = 'none'),
        (this.backFill32 = 'none'),
        (this.backFill33 = 'none'),
        (this.backFill34 = 'none'),
        (this.backFill35 = 'none'),
        (this.backFill36 = 'none'),
        (this.backFill37 = 'none'),
        (this.backFill38 = 'none'),
        //tooltip
        (this.toolTip28 = '');
    },
    tooltipText: function (bodyPartId) {
      const text = [...this.data]
        ?.filter((item) => bodyPartId === item?.bodyPartId)
        ?.map(({ typeOfInjury }) => typeOfInjury)
        ?.join(',');
      const finalTooltipText = text ? `${bodyPartId}-${text}` : '';
      return finalTooltipText;
    },
  },
  watch: {
    data: {
      handler: function (currentVal) {
        this.clearAllParts();
        currentVal.forEach(({ bodyPartId, color }) => {
          this.setColorToEachPart(bodyPartId, color);
        });
      },
      immediate: true,
    },
  },
};
